import React from "react";

import { useKeybanAuth } from "~/auth";
import { usePromise } from "~/promise";
import { useKeybanClient } from "~/provider";
import { ApiResult } from "~/types";

/**
 * Retrieves the current `optimisticBalance` associated with the Keyban client.
 * @returns - An array containing the account data, error, and an undefined value.
 */
export function useLoyaltyOptimisticBalance() {
  const client = useKeybanClient();
  const auth = useKeybanAuth();

  const [data, error, { refresh }] = usePromise(
    `loyalty:optimisticBalance:${auth.user?.id}`,
    () => client.api.loyalty.getOptimisticBalance().then(BigInt),
    { suspense: false },
  );

  React.useEffect(() => {
    const interval = setInterval(() => {
      try {
        refresh();
      } catch {
        console.warn(
          "Failed to refresh loyalty balance, keeping previous value",
        );
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [refresh, error, data]);

  return [data, error, undefined] as ApiResult<bigint>;
}
